<div class="dialog-container" style="padding: 24px">
  <div class="web-close-icon">
    <button matTooltipPosition="above" data-dismiss="modal" (click)="closedialog()" class="web-close-btn top-[-2.5px] right-[-3px]">
      <span class="material-icons" style="position: relative">clear</span>
    </button>
  </div>
  <div class="mobileCloseIcon">
    <p
      style="
        min-width: 60px;
        margin-bottom: 0px;
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        text-transform: uppercase;
      "
    >
      <span
        style="
          font-weight: bold;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          line-height: 25px;
          text-transform: capitalize;
        "
      >
        {{ data.isexistingUser ? 'Network request sent' : 'INVITATION SENT' }}
      </span>
    </p>
    <button type="button" class="close add-close-button mobile-close-btn" style="margin: auto" data-dismiss="modal" (click)="closedialog()">
      <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>

  <div class="main-contanier-admin-distributor" style="display: flex; flex-direction: column">
    <div class="name-container">
      <ngx-avatars size="36" src="{{ data.FullName }}" [name]="data.FullName | titlecase" [round]="true" initialsSize="2"></ngx-avatars>
      <div style="margin-left: 6px">
        <p class="success-title">{{ data.FullName | truncateStrPipe : 60 }}</p>
        <p class="success-title-grey">{{ data?.relationship_name ?? '' }}</p>
      </div>
    </div>
    @if (data.email) {
    <div class="icon-container">
      <img src="assets/images/email-grey.svg" />
      <p class="light-p">
        {{ data.email }}
      </p>
    </div>
    }

    <div class="icon-container">
      <mat-icon class="done-icon">done</mat-icon>
      <p class="dark-p">Invitation has been Sent</p>
    </div>
    <p class="success-subtitle">
      We recommend sharing this invite link with
      {{ data.FullName | truncateStrPipe : 60 }}
      via text or email to ensure it is received.
    </p>
    @if (!data.isexistingUser) {
    <div class="coply-container">
      <diV class="link-text text-truncate">
        {{ ShareUrl }}
      </diV>
      <div>
        <span (click)="copy()" style="margin-right: 10px; color: #353535" class="material-icons clickable">content_copy</span>
      </div>
    </div>
    }
  </div>
</div>
